// This one is not defined in fhirR4, so we need to define it here.
export enum AlertPriority {
  routine = "routine",
  urgent = "urgent",
  asap = "asap",
  stat = "stat",
}

// Enum used to specify the sort order for sorting data.
export enum SortOrder {
  ASCENDING = "ascending",
  DESCENDING = "descending",
}

// moved filter enums here as they are used in multiple places, not just in the AlertFilterBar component
//
// This might be a bit confusing as the AlertPriority above is really about the FHIR Task priority using in queries
// while the AlertSeverityFilterEnum and AlertStateFilterEnum are app domain alerts on top of FHIR tasks
export enum AlertSeverityFilterEnum {
  all = "all",
  severe = "severe",
  critical = "critical",
  moderate = "moderate",
  routine = "routine",
  // NOTE: the messages filter is not a severity filter, but a filter for the FHIR Communication resource
  messages = "messages",
}

export enum AlertStateFilterEnum {
  all = "all",
  active = "active",
  resolved = "resolved",
}

export enum ConditionCode {
  congestiveHeartFailure = "42343007",
}

export enum MfaMethod {
  NONE = "NONE",
  SMS_MFA = "SMS_MFA",
  SOFTWARE_TOKEN_MFA = "SOFTWARE_TOKEN_MFA",
  EMAIL_OTP = "EMAIL_OTP",
}

export interface UserMfaSettings {
  phone_number: string | null;
  phoneVerified: boolean;
  smsEnabled: boolean;
  status: MfaMethod;
  totpEnabled: boolean;
  emailEnabled: boolean;
}

export type IUser = {
  id: number;
  account_id?: string;
  name: string;
  firstName: string;
  lastName: string;
  email: string;
  avatar: string;
  roles?: string[];
  mfa?: UserMfaSettings;
  toc_completed?: boolean;
  pn_completed?: boolean;
  fhirPractitionerId?: string;
};

export enum PractitionerStatusEnum {
  Available = "available",
  Away = "away",
  Inactive = "inactive",
}
